import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import StoreService from "../../services/StoreService";
import Breadcrumb from "../../components/Breadcrumb";
import StorageService from "../../services/StorageService";
import MessageDialog from "../../components/MessageDialog";


export default function AddStore() {
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  // const messageTimer = useRef(null);
  const navigate = useNavigate();

  const { id } = useParams();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();


  useEffect(() => {
    if (id) {
      setIsEdit(true);
      setEditId(id);
      fetchStoreById(id);
    } else {
      setValue("status", "Active");
    }
  }, [id]);

  // **GET BY ID API CALL**
  const fetchStoreById = async (storeId) => {
    setEditLoading(true); // 🔄 START LOADING SPINNER
    try {
      const res = await StoreService.getById(storeId);

      if (res?.data) {
        const store = res.data;

        setValue("storeName", store.storeName || "");
        setValue("storeCode", store.storeCode || "");
        setValue("status", store.status || "Active");
      } else {
        showMessage("Failed to load Store details.", "error");
      }
    } catch (error) {
      console.error(error);
      showMessage("Error fetching Store details.", "error");
    } finally {
      setEditLoading(false);
    }
  };

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  const onSubmit = async (data) => {
    setLoading(true);

    try {
      let res;

      if (isEdit) {
        data.updatedBy = StorageService.loginData().employeeId;
        res = await StoreService.updateStore(editId, data);
        showMessage("Store updated successfully", "success");
      } else {
        data.createdBy = StorageService.loginData().employeeId;
        data.status = "Active";
        res = await StoreService.saveStore(data);
        showMessage("Store added successfully", "success");
      }

      setTimeout(() => navigate("/cpnl/store/view"), 1000);

    } catch (err) {
      console.error("Save Store Error:", err);

      const msg =
        err?.response?.data?.message ||
        err?.message ||
        "Error saving store";

      showMessage(msg, "error");
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <Breadcrumb
        pageTitle={isEdit ? "Modify Store" : "Add Store"}
        secondTitle="Masters"
      />

      <div className="row">
        <div className="card bg-white shadow-sm p-3">
          {/* {message && (
            <div
              className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
                } d-flex justify-content-between align-items-center mb-3 p-2`}
            >
              <span>{message}</span>
              <button
                type="button"
                className="btn-close"
                onClick={showMessage}
              />
            </div>
          )} */}
          
            <MessageDialog
              message={message}
              type={msgType}
              setMessage={setMessage}
              setMsgType={setMsgType}
            />
          

          {editLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary"></div>
              <div className="mt-2 text-muted">Loading data...</div>
            </div>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">
                    Store Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("storeName", {
                      required: "Store Name is required",
                    })}
                  />
                  {errors.storeName && (
                    <small className="text-danger">
                      {errors.storeName.message}
                    </small>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label">
                    Store Code <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("storeCode", {
                      required: "Store Code is required",
                    })}
                    onInput={(e) => {
                      e.target.value = e.target.value.toUpperCase();
                    }}
                  />
                  {errors.storeCode && (
                    <small className="text-danger">
                      {errors.storeCode.message}
                    </small>
                  )}
                </div>
              </div>

              <button
                type="submit"
                className="btn btn-primary mt-3"
                disabled={loading}
              >
                <i className="ti ti-circle-check me-1"></i>
                {loading
                  ? isEdit
                    ? "Updating..."
                    : "Saving..."
                  : isEdit
                    ? "Update"
                    : "Save"}
              </button>

              <button
                type="button"
                className="btn btn-secondary mt-3 ms-2"
                onClick={() => {
                  localStorage.removeItem("editStore");
                  navigate("/cpnl/store/view");
                }}
              >
                <i className="ti ti-cancel me-1"></i>
                Cancel
              </button>
            </form>
          )}
        </div>
      </div>
    </>
  );
}
